<template>
  <div class="basket__content">
    <div class="basket__list">
      <div class="b-top">
        <div class="b-top__count" v-html="Object.keys(moduleBasket.basket).length > 0 ? 'Добавлено товаров: <span>' + Object.keys(moduleBasket.basket).length + '</span>' : ''"></div>
        <div v-show="Object.keys(moduleBasket.basket).length > 0" class="b-top__clear" @click="this.CLEAR_BASKET">
          Очистить все
        </div>
      </div>
      <div v-if="Object.keys(moduleBasket.basket).length > 0" class="b-items">
        <basket-item v-for="item in moduleBasket.basket" :key="item.bid" :item="item"></basket-item>
      </div>
      <div v-else>
        Ваша корзина пуста.
      </div>
      <a class="b-back btn--white" href="/catalog/">Вернуться к покупкам</a>
    </div>
    <div v-show="Object.keys(moduleBasket.basket).length > 0" class="basket__form">
      <div class="b-form">
        <div class="b-form__title">Ваша корзина</div>
        <div class="b-form__goods">
          <div class="b-form__goods-title" v-html="'Товары (' + Object.keys(this.moduleBasket.basket).length + ')'"></div>
          <div v-if="moduleBasket.default_sum > 0" class="b-form__goods-price">
            <animated-number :number="Number(moduleBasket.default_sum)"></animated-number>
          </div>
        </div>
        <div class="b-form__more">Подробнее</div>
        <div class="b-form__list">
          <a v-for="item in moduleBasket.basket" :key="item.bid" class="b-form__item" :href="item.DETAIL_PAGE_URL">
            <div class="b-form__item-title">{{ item.NAME }}
              <span>({{ item.QUANTITY }}&nbsp;шт.)</span>
            </div>
            <div v-if="Number(item.DEFAULT_PRICE) > 0" class="b-form__item-price">
              <animated-number :number="Number(item.DEFAULT_PRICE)"></animated-number>
            </div>
          </a>
        </div>
        <div class="b-form__total">
          <!--          <div v-if="parseInt(moduleBasket.easy_clean_sum) > 0"-->
          <!--               class="b-form__item">-->
          <!--            <div class="b-form__item-title">{{ moduleEasyClean.name }}</div>-->
          <!--            <div class="b-form__item-price"> +-->
          <!--              <animated-number :number="Number(moduleBasket.easy_clean_sum)"></animated-number>-->
          <!--            </div>-->
          <!--          </div>-->
          <div v-if="parseInt(moduleBasket.discount_sum) > 0" class="b-form__item">
            <div class="b-form__item-title">Скидка</div>
            <div class="b-form__item-price">
              -
              <animated-number :number="Number(moduleBasket.discount_sum)"></animated-number>
            </div>
          </div>
          <div class="b-form__item">
            <div class="b-form__item-title">Общая стоимость</div>
            <div v-if="moduleBasket.total_sum > 0" class="b-form__item-price">
              <animated-number :number="Number(moduleBasket.total_sum)"></animated-number>
            </div>
          </div>
        </div>
        <div class="b-form__btn">
          <a class="btn btn--middle" :href="link">Оформить заказ</a>
          <a class="btn--white btn--white--midlle" data-popup="#quickOrder">Купить в 1 клик</a>
        </div>
        <div class="b-form__privacy">Нажимая кнопку, Вы даете информированное согласие <br> на
          <a target="_blanc" :href="modulePolicy.file_src">обработку своих персональных данных</a>
        </div>
      </div>
    </div>
    <div class="popup  popup--quick" id="quickOrder">
      <quick-order-form :fio_prop="fio" :phone_prop="phone" :email_prop="email"></quick-order-form>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import BasketItem             from "@/components/Basket/BasketItem";
import QuickOrderForm         from "@/components/Order/QuickOrderForm";
import AnimatedNumber         from "@/components/Animation/AnimatedNumber";

export default {
  name       : "BigBasket",
  components : {
    BasketItem,
    QuickOrderForm,
    AnimatedNumber
  },
  props      : {
    link  : String,
    fio   : String,
    phone : String,
    email : String
  },
  computed   : {
    ...mapState([
      "moduleBasket", "modulePolicy"
      // "moduleEasyClean"
    ]),
    discount()
    {
      let val = 0;
      for(let basketKey in this.moduleBasket.basket)
      {
        val
            += parseFloat(this.moduleBasket.basket[basketKey].DISCOUNT) * parseFloat(this.moduleBasket.basket[basketKey].QUANTITY);
      }
      return this.formatPrice(val);
    }
  },
  methods    : {
    ...mapActions([
      "CLEAR_BASKET"
    ]),
    formatPrice( val )
    {
      return val.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
  }
};
</script>

<style scoped>

</style>